import type { UserAlertAPI } from './definitions/ApiTypes';
import type { UserAlert } from './definitions/Types';
import { toUserAlert, toUserAlertPage } from './userAlertTransformer';
import { gql } from '@apollo/client';

import type { DateRange, PageableContent, PageableContentAPI, Sort } from '@cobliteam/common-types';

import graphQLRequester from '../../../request/GraphQLRequester';
import type { UserAlertsFilters } from '../commons';

export class GraphQLUserAlertRequester {
  public getAlerts = (period: DateRange, page: number, size: number, filters?: UserAlertsFilters, sort?: Sort): Promise<PageableContent<UserAlert>> =>
    graphQLRequester
      .query<{ alert: PageableContentAPI<UserAlertAPI> }>({
        query: gql`
          query getAlerts(
            $period: DateRange
            $page: Int
            $size: Int
            $filters: Filters
            $sort: Sort
          ) {
            alert(
              period: $period
              page: $page
              size: $size
              filters: $filters
              sort: $sort
            ) {
              last
              total_pages
              total_elements
              number_of_elements
              number
              size
              first
              empty

              content {
                id
                vehicle_id
                driver_id
                vehicle_group_id
                type
                processed_at
                ... on RoadSpeedLimitAlert {
                  duration_in_millis
                  speed_limit_in_km_h
                  speed_in_km_h
                  severity
                }
                ... on VehicleSpeedLimitAlert {
                  duration_in_millis
                  speed_limit_in_km_h
                  speed_in_km_h
                }
                ... on StopIdleTimeAlert {
                  duration_in_millis
                }
                # TODO: Let's investigate performance impact of this first!
                # driver {
                #   name
                # }
                # vehicle {
                #   id
                #   license_plate
                #   model {
                #     brand
                #     name
                #   }
                #   groups {
                #     id
                #     name
                #   }
                # }
              }
            }
          }
        `,
        variables: { period, page, size, filters, sort },
      })
      .then((result) => toUserAlertPage(result.alert));

  public getUnpagedAlerts = (period: DateRange, filters?: UserAlertsFilters): Promise<UserAlert[]> =>
    graphQLRequester
      .query<{ alert: Pick<PageableContent<UserAlertAPI>, 'content'> }>({
        query: gql`
          query getAlerts($period: DateRange, $filters: Filters) {
            alert(period: $period, filters: $filters) {
              content {
                id
                vehicle_id
                driver_id
                vehicle_group_id
                type
                processed_at
                ... on RoadSpeedLimitAlert {
                  duration_in_millis
                  speed_limit_in_km_h
                  speed_in_km_h
                  severity
                }
                ... on VehicleSpeedLimitAlert {
                  duration_in_millis
                  speed_limit_in_km_h
                  speed_in_km_h
                }
                ... on StopIdleTimeAlert {
                  duration_in_millis
                }
              }
            }
          }
        `,
        variables: { period, filters },
      })
      .then((result) => result.alert.content.map(toUserAlert));
}

export default GraphQLUserAlertRequester;
